var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngineering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3529 5.20001H21.7759V26H24.3529V5.20001Z",
    fill: "#BDCCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44251 15.6H3.86548V36.4H6.44251V15.6Z",
    fill: "#BDCCD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1344 15.6H39.5574V36.4H42.1344V15.6Z",
    fill: "#BDCCD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4201 4.03003L4.50977 14.43L5.79828 16.64L23.7086 6.24003L22.4201 4.03003Z",
    fill: "#BDCCD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79828 14.43L4.50977 16.64L22.4201 27.04L23.7086 24.83L5.79828 14.43Z",
    fill: "#BDCCD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7087 4.03003L22.4202 6.24003L40.3305 16.64L41.619 14.43L23.7087 4.03003Z",
    fill: "#BDCCD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2016 14.43L22.2913 24.83L23.5798 27.04L41.4901 16.64L40.2016 14.43Z",
    fill: "#BDCCD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3529 26H21.7759V46.8H24.3529V26Z",
    fill: "#BDCCD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4201 24.83L4.50977 35.23L5.79828 37.44L23.7086 27.04L22.4201 24.83Z",
    fill: "#BDCCD4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79828 35.23L4.50977 37.44L22.4201 47.84L23.7086 45.63L5.79828 35.23Z",
    fill: "#BDCCD4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7087 24.83L22.4202 27.04L40.3305 37.44L41.619 35.23L23.7087 24.83Z",
    fill: "#BDCCD4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2016 35.23L22.2913 45.63L23.5798 47.84L41.4901 37.44L40.2016 35.23Z",
    fill: "#BDCCD4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0645 10.4C25.8992 10.4 28.2185 8.06 28.2185 5.2C28.2185 2.34 25.8992 0 23.0645 0C20.2297 0 17.9104 2.34 17.9104 5.2C17.9104 8.06 20.2297 10.4 23.0645 10.4Z",
    fill: "#0AE8F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15406 20.8C7.9888 20.8 10.3081 18.46 10.3081 15.6C10.3081 12.74 7.9888 10.4 5.15406 10.4C2.31933 10.4 0 12.74 0 15.6C0 18.46 2.31933 20.8 5.15406 20.8Z",
    fill: "#006BFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15406 41.6C7.9888 41.6 10.3081 39.26 10.3081 36.4C10.3081 33.54 7.9888 31.2 5.15406 31.2C2.31933 31.2 0 33.54 0 36.4C0 39.26 2.31933 41.6 5.15406 41.6Z",
    fill: "#0AE8F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.846 20.8C43.6807 20.8 46 18.46 46 15.6C46 12.74 43.6807 10.4 40.846 10.4C38.0112 10.4 35.6919 12.74 35.6919 15.6C35.6919 18.46 38.0112 20.8 40.846 20.8Z",
    fill: "#0AE8F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.846 41.6C43.6807 41.6 46 39.26 46 36.4C46 33.54 43.6807 31.2 40.846 31.2C38.0112 31.2 35.6919 33.54 35.6919 36.4C35.6919 39.26 38.0112 41.6 40.846 41.6Z",
    fill: "#006BFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0645 52C25.8992 52 28.2185 49.66 28.2185 46.8C28.2185 43.94 25.8992 41.6 23.0645 41.6C20.2297 41.6 17.9104 43.94 17.9104 46.8C17.9104 49.66 20.2297 52 23.0645 52Z",
    fill: "#0AE8F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0645 31.2C25.8992 31.2 28.2185 28.86 28.2185 26C28.2185 23.14 25.8992 20.8 23.0645 20.8C20.2297 20.8 17.9104 23.14 17.9104 26C17.9104 28.86 20.2297 31.2 23.0645 31.2Z",
    fill: "#006BFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering);
export default __webpack_public_path__ + "static/media/engineering.32bb5e12d7b4378d65d54e7a235a634c.svg";
export { ForwardRef as ReactComponent };